export class PagedApiResponse<T> {
  rows: Array<T>;
  count: number;
}
